import React from "react";
export const CloseSideBar = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="11.5"
        fill="white"
        stroke="url(#paint0_linear_2036_64597)"
      />
      <path
        d="M9.20924 11.0037L12.888 7.19918C12.9485 7.13607 13.0204 7.08597 13.0996 7.05179C13.1788 7.0176 13.2637 7 13.3495 7C13.4353 7 13.5203 7.0176 13.5995 7.05179C13.6787 7.08597 13.7506 7.13607 13.811 7.19918C13.9321 7.32534 14 7.49601 14 7.6739C14 7.85179 13.9321 8.02245 13.811 8.14862L10.5937 11.5154L13.811 14.8486C13.9321 14.9747 14 15.1454 14 15.3233C14 15.5012 13.9321 15.6718 13.811 15.798C13.7508 15.8616 13.679 15.9122 13.5998 15.9469C13.5206 15.9816 13.4355 15.9996 13.3495 16C13.2635 15.9996 13.1785 15.9816 13.0992 15.9469C13.02 15.9122 12.9482 15.8616 12.888 15.798L9.20924 11.9935C9.14327 11.9305 9.09062 11.8539 9.0546 11.7687C9.01859 11.6836 9 11.5916 9 11.4986C9 11.4056 9.01859 11.3136 9.0546 11.2284C9.09062 11.1432 9.14327 11.0667 9.20924 11.0037Z"
        fill="url(#paint1_linear_2036_64597)"
        stroke="url(#paint2_linear_2036_64597)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2036_64597"
          x1="1.08965e-07"
          y1="12"
          x2="24"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#775FD5" />
          <stop offset="1" stop-color="#F03A85" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2036_64597"
          x1="14"
          y1="11.5"
          x2="9"
          y2="11.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#775FD5" />
          <stop offset="1" stop-color="#F03A85" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2036_64597"
          x1="14"
          y1="11.5"
          x2="9"
          y2="11.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#775FD5" />
          <stop offset="1" stop-color="#F03A85" />
        </linearGradient>
      </defs>
    </svg>
  );
};
